import { render, staticRenderFns } from "./movie-order-create.vue?vue&type=template&id=a131f320"
import script from "./movie-order-create.vue?vue&type=script&lang=js"
export * from "./movie-order-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports